import _o2sService from "./_o2sServices";
import { ICenterFilter } from "../models/filters/centerFilter";
import { IFilter } from "../models/filters/filter";
import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";

export default class CenterService extends _o2sService {

    protected static mainUrl:string = API_CENTRE +"/api/v1/centers";

    // CenterPDTO backend : la propriété Id throws NotImplementedException → ne pas l'envoyer dans le corps
    public static override async update<o extends { id: number }, R extends { id: number }>(dataObj: o): Promise<any> {
        try {
            const { id, ...bodyWithoutId } = dataObj as any;
            const result = await apiCallWithAuth(this.mainUrl + "/" + id, "put", bodyWithoutId);
            return this.ReturnObject(result);
        } catch (err) {
            return this.ReturnError(err);
        }
    }

    static getUrlFilter<F extends ICenterFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != undefined)
        {
            if ( filter.code != undefined)
                url += `&Code=${filter.code}`;
            if ( filter.speciesId != undefined)
                url += `&SpeciesId=${filter.speciesId}`;
        }
        return url;
    }


}